import { ChevronDown, ChevronUp, } from "lucide-react";

import CenteredTitle from "shared/components/title/CenteredTitle";
import { useState } from "react";
import { useTranslation } from 'react-i18next';

const FAQSection = () => {
    const { t } = useTranslation();
    const [openIndex, setOpenIndex] = useState(0);

    const toggleFAQ = (idx) => {
        setOpenIndex(openIndex === idx ? null : idx);
    };

    return (
        <section
            id="faqs"
            className="w-full py-0 px-6 mb-12 flex flex-col items-center bg-white"
        >
            <CenteredTitle
                title={t('website.faq.title')}
                subtitle={t('website.faq.subtitle')}
            />
            <div className="w-full max-w-4xl space-y-6 mt-8">
                {
                    faqs.map((faq, idx) => (
                        <FAQItem idx={idx} toggleFAQ={toggleFAQ} openIndex={openIndex} faq={faq} />
                    ))
                }
            </div>
        </section>
    );
};

export default FAQSection;

function FAQItem({ idx, toggleFAQ, openIndex, faq }) {
    const { t } = useTranslation();

    return (
        <div key={idx} className="border-b border-gray-200 pb-4 cursor-pointer" onClick={() => toggleFAQ(idx)}>
        <div className="flex items-center justify-between">
            <p className={`text-xl font-medium  ${openIndex === idx ? "text-lime-700" : "text-gray-700"}`}>
                {t(`website.faq.questions.${idx + 1}.question`)}
            </p>
            {openIndex === idx ? <ChevronUp className="text-gray-500" /> : <ChevronDown className="text-gray-500" />}
        </div>

        {openIndex === idx && <p className="mt-3 text-gray-600 leading-relaxed text-sm">
            {t(`website.faq.questions.${idx + 1}.answer`)}
        </p>}
    </div>);
}

const faqs = [
    {
        question: "What exactly is meetsNworks?",
        answer:
            "meetsNworks allows you to discover, book, and access premium workspaces effortlessly—from desks to meeting rooms.",
    },
    {
        question: "Can I customize my workspace booking?",
        answer:
            "Yes. You can choose amenities and room settings depending on availability at each location.",
    },
    {
        question: "What payment methods are supported?",
        answer:
            "We support major cards, mobile payments, and other secure online payment methods depending on your region.",
    },
    {
        question: "Are the workspaces available 24/7?",
        answer:
            "Some locations are open 24/7. Availability varies by workspace and will be shown during booking.",
    },
    {
        question: "Is cancellation or rescheduling allowed?",
        answer:
            "Yes, depending on the workspace's policy. Cancellation rules are shown before final checkout.",
    },
];
